<template>
    <div class="history">
        <template v-for="(it, index) in history">
            <slot>
                <div :key="index" class="item">
                    <button class="no-border iconed select"
                            @click="select(it.query, it.tags)">
                        <IconHistory class="icon history-icon" />
                        <div class="tags product-tag">
                            <span v-for="tagId in it.tags"
                                  :key="tagId"
                                  :class="[allTagsMap[tagId].class]"
                                  class="item">
                                #{{ allTagsMap[tagId].name }}
                            </span>
                        </div>
                        <span class="query">{{ it.query }}</span>
                    </button>

                    <button class="no-border delete" @click="removeHistoryTag(it, index)">
                        <IconClose class="icon" />
                    </button>
                </div>
            </slot>
        </template>

        <template v-if="history.length === 0">
            <slot name="empty">
                <div class="empty item">История поиска пуста</div>
            </slot>
        </template>
    </div>
</template>

<script>
import { tagsToMap } from '@/common/page_comp/Tag/util.js';
import Local from '@/common/util/local.js';
import { allTags } from '@/restapi/tag/tag.js';
import { toMap } from '@dsee/util/arrays';
import IconHistory from '@/common/page_comp/SearchProduct/icons/history.svg?component';
import { SEARCH_HIST_KEY } from '../config.history.js';

export default {
    name: 'SearchHistory',
    components: {
        IconHistory,
    },
    data() {
        return {
            history: [],

            dicts: {
                allTags: [],
            },
        };
    },
    computed: {
        allTagsMap() {
            return toMap(tagsToMap(this.dicts.allTags));
        },
    },
    async created() {
        this.dicts.allTags = await allTags();
        this.updateHistory();
    },
    methods: {
        tagsToMap,
        removeHistoryTag(it, index) {
            this.history.splice(index, 1);
            Local.put(SEARCH_HIST_KEY, this.history);
        },
        updateHistory() {
            this.history = Local.get(SEARCH_HIST_KEY, []);
        },
        select(query, tags) {
            this.$emit('select', query, tags);
        },
    },
};
</script>

<style lang="scss" scoped>
.history {

    & > .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        padding: var(--input-padding);
        border-radius: var(--input-border-radius);

        &:hover {
            background: var(--option-hover-background);
        }
    }

    .select {
        flex: 1;
        max-width: 100%;
        overflow: hidden;
    }

    .history-icon {
        opacity: 0.5;
        color: var(--text-color);
    }

    .tags {
        display: inline-flex;
    }

    .query {
        flex: 1;
        margin-left: 8px;
        color: var(--text-color);
        font-weight: 400;
        text-align: left;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .delete {
        margin-left: 8px;
        flex: none;
        opacity: 0.25;
        color: var(--text-color);
    }

    .empty {
        color: var(--input-disabled-color);
    }
}
</style>
